import { numberToPrettyString } from '@cian/utils';

import { TOfferCategory } from '../../../../types/offer';
import { getIsDailyRent } from './getIsDailyRent';
import { getPaymentPeriod } from './getPaymentPeriod';

export interface IGetRentPriceParams {
  priceRur: number;
  category: TOfferCategory | null;
}

export function getRentPrice({ priceRur, category }: IGetRentPriceParams): string {
  const price = `${numberToPrettyString(priceRur)} ₽/${getPaymentPeriod(category)}`;
  const isDailyRent = getIsDailyRent(category);

  if (isDailyRent) {
    return `от ${price}`;
  }

  return price;
}
